import { Map, List } from "immutable";
import { CIBIL_ACTIONS } from "constants/actions";
import { STATE_STATUS } from "constants/state-status";

const INITIAL_STATE = new Map({
    open: new Map({
        status: undefined,
        data: new Map({}),
        pages: new Map({}), 
        count: null
    }),
    close: new Map({
        status: undefined,
        data: new Map({}),
        pages: new Map({}),
        count: null
    }),
    "pending-approval": new Map({
        status: undefined,
        data: new Map({}),
        pages: new Map({}),
        count: null
    }),
    current_tab: "open"
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case CIBIL_ACTIONS.FETCH_CIBIL_DETAILS:
        return state.setIn([
            payload.requestType,
            "status"
        ], STATE_STATUS.FETCHING)
            .set("current_tab", payload.requestType);
    case CIBIL_ACTIONS.FETCHED_CIBIL_DETAILS:
        return state
            .setIn([
                payload.requestType,
                "status"
            ], STATE_STATUS.FETCHED)
            .setIn([payload.requestType, "count"], payload.data && payload.data.count)
            .setIn([payload.requestType, "data"], new List((payload.data && payload.data.results) || []).toMap().mapEntries(([, v]) => ([v.id, v])));
    case CIBIL_ACTIONS.FAILED_FETCH_CIBIL_DETAILS:
        return state
            .setIn([
                payload.requestType,
                "status"
            ], STATE_STATUS.FETCH_FAILED);
    case CIBIL_ACTIONS.UPDATE_CIBIL_DETAILS:
        return state.setIn([
            payload.requestType,
            "status"
        ], STATE_STATUS.UPDATING);
    case CIBIL_ACTIONS.UPDATED_CIBIL_DETAILS: {
        let payloadData = payload.data && payload.data.map(_ => _.id);
        return state.setIn([
            payload.requestType,
            "status"
        ], STATE_STATUS.UPDATED)
            .setIn([payload.requestType, "data"], state.getIn([payload.requestType, "data"]).filter(_ => !payloadData.includes(_.id)));
    }
    case CIBIL_ACTIONS.FAILED_UPDATE_CIBIL_DETAILS:
        return state.setIn([
            payload.requestType,
            "status"
        ], STATE_STATUS.UPDATE_FAILED);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};